require('./helpers/bundle-manifest').register(JSON.parse("{\"cD01m\":\"index.0c98add4.js\",\"iVX5i\":\"logo.0a6936ba.svg\",\"12Neq\":\"index.803a0ad7.css\"}"));